import { render, staticRenderFns } from "./deliveryTabSsw.vue?vue&type=template&id=d15126c0&scoped=true"
import script from "./deliveryTabSsw.vue?vue&type=script&lang=js"
export * from "./deliveryTabSsw.vue?vue&type=script&lang=js"
import style0 from "./deliveryTabSsw.vue?vue&type=style&index=0&id=d15126c0&lang=scss"
import style1 from "./deliveryTabSsw.vue?vue&type=style&index=1&id=d15126c0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d15126c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d15126c0')) {
      api.createRecord('d15126c0', component.options)
    } else {
      api.reload('d15126c0', component.options)
    }
    module.hot.accept("./deliveryTabSsw.vue?vue&type=template&id=d15126c0&scoped=true", function () {
      api.rerender('d15126c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/dialog/deliveryTab/deliveryTabSsw.vue"
export default component.exports